import React, { useEffect, useState } from "react";

// Material Icons
import { Add, Cancel, ShoppingBag } from "@mui/icons-material";

// UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

// Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

// Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

// Dictionaries
import { productTypes } from "../../Dictionaries/products";

export default function SetProductDrawer({
  isNewProduct = true,
  existingProductData = {},
  open,
  setOpen,
  getData,
}) {
  // Component States
  const [productData, setProductData] = useState({
    productName: "",
    type: 0,
    priceInCRC: "",
    priceInUSD: "",
    details: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalDescription, setModalDescription] = useState("");

  useEffect(() => {
    if (existingProductData && Object.keys(existingProductData).length > 0) {
      const typeIndex = productTypes.findIndex(
        (p) => p.value === existingProductData.type
      );
      setProductData({
        productName: existingProductData.productName || "",
        type: typeIndex !== -1 ? typeIndex : 0,
        priceInCRC: existingProductData.priceInCRC || "",
        priceInUSD: existingProductData.priceInUSD || "",
        details: existingProductData.details || "",
      });
    }
  }, [existingProductData]);

  const addProductForm = [
    {
      selection: "textfield",
      id: "productName",
      initialValue: productData.productName,
      xs: 12,
      md: 6,
      label: "Nombre del producto",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre del producto",
      content: [],
      style: {},
    },
    {
      selection: "selector",
      id: "type",
      initialValue: productData.type,
      xs: 12,
      md: 6,
      label: "Tipo de producto",
      multiline: false,
      type: null,
      inputProps: {},
      placeholder: "",
      content: productTypes.map((p) => p.value),
      style: { minWidth: "100%" },
    },
    {
      selection: "textfield",
      id: "details",
      initialValue: productData.details,
      xs: 12,
      md: 12,
      label: "Detalles del producto",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Detalles del producto",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "priceInUSD",
      initialValue: productData.priceInUSD,
      xs: 12,
      md: 6,
      label: "Precio en dólares (USD)",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Precio USD",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "priceInCRC",
      initialValue: productData.priceInCRC,
      xs: 12,
      md: 6,
      label: "Precio en colones (CRC)",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Precio CRC",
      content: [],
      style: {},
    },
  ];

  const setProduct = async () => {
    setIsLoading(true);

    const newProduct = {
      productId: existingProductData.productId,
      productName: productData.productName,
      type: productTypes[productData.type]?.value,
      priceInCRC: productData.priceInCRC,
      priceInUSD: productData.priceInUSD,
      details: productData.details,
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        isNewProduct ? "/products/create" : "/products/edit-product",
        newProduct
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText(
          isNewProduct
            ? "Producto registrado exitosamente."
            : "Producto editado exitosamente."
        );
        setModalDescription(jsonResponse.description);
        getData();
        setOpen(false);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
      setModalText("Error inesperado");
      setModalDescription("Ocurrió un error al intentar procesar la solicitud.");
    }

    setModalOpen(true);
    setIsLoading(false);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {}}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <ShoppingBag color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            {isNewProduct
              ? "Nuevo producto"
              : "Editar información del producto"}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form data={addProductForm} handleStateChange={setProductData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => setOpen(false)}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={productData.productName === ""}
                onClick={setProduct}
              >
                {isNewProduct ? "Registrar producto" : "Guardar cambios"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => setModalOpen(false)}
      />
    </SwipeableDrawer>
  );
}
